import React, { Component } from "react";
import "./MedicalRecordsMaintenance.component.css";

class MedicalRecordsMaintenance extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return(
            <div className="container no-enrollments">
                <div className="row">
                    <div className="d-none d-sm-block col-6 col-sm-5 col-lg-4 px-0">
                        <img
                            className="img-fluid no-enrollments-image"
                            src="../../assets/images/no-enrollments.jpg"
                            alt="worth-the-wait"
                        />
                        </div>
                    <div className="col col-sm-7 col-lg-8">
                        <h1 className="text-primary mb-3 mb-lg-0 sorry">
                            Sorry
                        </h1>
                        <p class="">
                        We are currently experiencing technical difficulties with submissions through our Customer Center and mobile app.
If you need to submit a claim or medical records, please email them to:  
<br/><br/>
                            <a href={"mailto:records@healthypaws.com"}>records@healthypaws.com</a>
<br/><br/>
This issue may cause delays to claim processing times. We are working hard to process your claims as quickly as possible and appreciate your patience.

                        </p>
                        <button
                            className="button-primary back-to-home"
                            type="submit"
                            onClick={this.props.backToHome}
                            >
                            Home
                            </button>
                    </div>
                </div>
            </div>
        );
    }
}
  
export default MedicalRecordsMaintenance;